import { clientActions } from './client-slice';

export const setClient = (dispatch, client) => {
  dispatch(clientActions.setClient(client));
};
